module.exports = __webpack_public_path__ + "assets/img/c76c-jp.svg";